import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '+800',
    label: 'Profesionales confían en el sistema'
  }, {
    value: '4.9/5',
    label: 'Valoración promedio'
  }, {
    value: '+180',
    label: 'Recursos clínicos y protocolos'
  }, {
    value: '#1',
    label: 'Sistema elegido en Argentina'
  }];
  return <section className="py-10 border-y border-navy-lighter bg-navy-light/30" data-id="element-177">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-179">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center space-y-2" data-id="element-180">
              <span className="text-3xl md:text-4xl font-serif font-bold text-gold" data-id="element-181">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-gray-400 font-medium" data-id="element-182">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}